function openModal() {
    document.getElementById('myModal').style.display = "block";
    //$('#products').hide();
    //$('#lightSlider').hide();
  }
  
  // Close the Modal
  function closeModal() {
    document.getElementById('myModal').style.display = "none";
    //$('#products').show();
    //$('#lightSlider').show();
  }